import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClientReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/client-reviews`)
      .then((res) => setReviews(res.data.reviews || []))
      .catch(() => setReviews([]));
  }, []);

  if (reviews.length === 0) return null;

  // Duplicate for seamless marquee loop
  const loop = [...reviews, ...reviews];

  return (
    <section
      data-testid="client-reviews-section"
      className="relative py-20 md:py-28 overflow-hidden border-t border-[#F0EBE1]/10 bg-[#0B0F18]"
    >
      <div className="px-6 md:px-12 lg:px-24 mb-12 md:mb-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="reveal">
            <div className="overline mb-4">Client Reviews</div>
            <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.05] tracking-tight">
              Loved by families
              <br />
              and <span className="italic text-[#B8935C]">friends</span>.
            </h3>
          </div>
          <div className="reveal max-w-md text-[#F0EBE1]/65 text-sm sm:text-base leading-relaxed font-light">
            Short notes from weddings, engagements, birthdays and casino-themed
            evenings we've had the joy of crafting.
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="flex gap-6 marquee-track w-max">
          {loop.map((r, i) => (
            <article
              key={`${r.name}-${i}`}
              data-testid={`client-review-${i % reviews.length}`}
              className="w-[320px] md:w-[400px] flex-shrink-0 bg-[#121623]/70 border border-[#F0EBE1]/10 p-6 md:p-7"
            >
              <p className="text-[#F0EBE1]/75 text-sm leading-relaxed font-light italic line-clamp-6">
                "{r.quote}"
              </p>
              <div className="mt-5 pt-4 border-t border-[#F0EBE1]/10">
                <div className="overline text-[10px] text-[#B8935C]">
                  {r.name}
                </div>
              </div>
            </article>
          ))}
        </div>
        {/* edge fades */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B0F18] to-transparent"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B0F18] to-transparent"
        />
      </div>
    </section>
  );
};

export default ClientReviews;
